import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, computed, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { store } from '@/vue/store'

interface Vue2Instance {
  $mount: (elementOrSelector?: string | Element, hydrating?: boolean) => this
  $destroy: () => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MicroViewVue2',
  setup(__props) {

let vue2AppInstance: Vue2Instance | null = null
const route = useRoute()
const router = useRouter()

const container = ref<HTMLElement | null>(null)

const routeName = computed(() => route.name)

onMounted(async () => {
  if (routeName.value && container.value !== null && routeName.value in store.MICROINSTALLERS) {
    container.value.innerHTML = ''
    vue2AppInstance = await store.MICROINSTALLERS[routeName.value]('#application-vue-2')
  }
})

onUnmounted(() => {
  if (vue2AppInstance && vue2AppInstance.$destroy) {
    vue2AppInstance.$destroy()
  }
  if (routeName.value) {
    if (container.value) {
      container.value.innerHTML = ''
    }
    router.removeRoute(routeName.value)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "application-vue-2",
    ref_key: "container",
    ref: container
  }, null, 512))
}
}

})